import { TrendingUp, Shield, DollarSign, Waves, Plane, TreePine } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const HUATULCO_AERIAL = "/assets/images/location-aerial-2.webp";
const FAUNA_IMAGE = "/assets/images/huatulco-ziba.webp";

const statIcons = [TrendingUp, Shield, DollarSign, Waves, Plane];

const DestinationSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="destination-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="relative mb-12 overflow-hidden" style={{ height: "400px" }}>
          <img src={HUATULCO_AERIAL} alt="Huatulco Aerial View" className="w-full h-full object-cover" loading="lazy" decoding="async" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent" />
          <div className="absolute bottom-0 left-0 p-8 md:p-12">
            <span className="text-xs uppercase tracking-[0.3em] text-[#D4A03D] font-accent mb-4 block">{t.destination.label}</span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-white max-w-2xl" data-testid="destination-title">{t.destination.title}</h2>
          </div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 mb-16">
          <div className="space-y-6 bg-white p-8 md:p-12 shadow-lg">
            <p className="text-[#6B6560] leading-relaxed text-lg">{t.destination.p1}</p>
            <p className="text-[#6B6560] leading-relaxed">{t.destination.p2}</p>
            <p className="text-[#6B6560] leading-relaxed">{t.destination.p3}</p>
            <p className="text-[#6B6560] leading-relaxed">{t.destination.p4}</p>
          </div>
          <div className="relative">
            <div className="overflow-hidden shadow-lg">
              <img src={FAUNA_IMAGE} alt="Huatulco" className="w-full h-full object-cover" loading="lazy" decoding="async" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#B5613B] flex items-center justify-center">
              <TreePine className="w-10 h-10 text-white" />
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {t.destination.stats.map((stat, index) => {
            const Icon = statIcons[index];
            return (
              <div key={index} className="bg-[#2D2926] p-6 text-center" data-testid={`destination-stat-${index}`}>
                <Icon className="w-6 h-6 text-[#D4A03D] mx-auto mb-3" />
                <span className="font-heading text-2xl md:text-3xl text-[#D4A03D] block mb-2">{stat.value}</span>
                <span className="text-sm text-white font-medium block mb-1">{stat.label}</span>
                <span className="text-xs text-white/50">{stat.note}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DestinationSection;
